import { ACTIVITIES, type ActivityKey } from "../activities";

/**
 * Multi-select chip picker for trail / org activities.
 *
 * Parent owns the `Set<ActivityKey>` and a toggle handler. No
 * network calls happen here — the parent's save action is the only
 * place that talks to the API, mirroring AmenityPickerGrid's
 * pattern. Used in both TrailDrawer (curator catalog edit) and
 * OrgDrawer (org-level taxonomy).
 *
 * Renders the same `.amenities-grid` / `.amenity-chip` class names
 * as the amenities picker so the chip silhouette stays identical;
 * activity-specific styling sits in `.amenity-chip.activity` if
 * we ever need to diverge.
 */
export function ActivityChipPicker({
  selected,
  onToggle,
}: {
  selected: Set<ActivityKey>;
  onToggle: (key: ActivityKey) => void;
}) {
  return (
    <div className="amenities-grid">
      {ACTIVITIES.map((activity) => {
        const isOn = selected.has(activity.key);
        return (
          <button
            key={activity.key}
            type="button"
            className={`amenity-chip activity ${isOn ? "on" : ""}`}
            onClick={() => onToggle(activity.key)}
            aria-pressed={isOn}
          >
            <span className="amenity-icon">{activity.icon}</span>
            <span className="amenity-label">{activity.label}</span>
          </button>
        );
      })}
    </div>
  );
}
